import React, { useState } from "react";
import styled from "styled-components";
import { FooterButtonContainer, StyledModal } from "./components/styled-modal";
import { Button } from "@interstate/components/Button";
import { CheckBox } from "@interstate/components/CheckBox";
import { setTaskAlertDismissed } from "../utils/task-alert-utils";
import {
  taskIncompleteModalCheckboxTestId,
  taskIncompleteModalContainerTestId,
  taskIncompleteModalContentTestId,
  taskIncompleteModalLeaveButtonTestId,
  taskIncompleteModalStayButtonTestId
} from "../testIds";

interface TaskIncompleteModalProps {
  /** Whether the modal is open */
  isOpen: boolean;
  /** Function called when user clicks "Stay" to cancel tab change */
  onStay: () => void;
  /** Function called when user clicks "Leave" to proceed with tab change */
  onLeave: () => void;
}

const ModalContent = styled.div`
  padding: 24px;
`;

const CheckboxContainer = styled.div`
  margin-top: 16px;
`;

const CheckboxLabel = styled.span`
  font-size: 14px;
  color: #333333;

  strong {
    font-weight: 600;
  }
`;

export function TaskIncompleteModal({
  isOpen,
  onStay,
  onLeave
}: TaskIncompleteModalProps) {
  const [dontShowAgain, setDontShowAgain] = useState(false);

  const handleCheckboxChange = () => {
    const newValue = !dontShowAgain;
    setDontShowAgain(newValue);
  };

  const handleStay = () => {
    // Save preference to localStorage if checkbox is checked
    if (dontShowAgain) {
      setTaskAlertDismissed();
    }
    onStay();
  };

  const handleLeave = () => {
    // Save preference to localStorage if checkbox is checked
    if (dontShowAgain) {
      setTaskAlertDismissed();
    }
    onLeave();
  };

  const modalFooter = (
    <FooterButtonContainer>
      <Button
        buttonStyle="secondary"
        data-testid={taskIncompleteModalStayButtonTestId}
        onClick={handleStay}
      >
        Stay
      </Button>
      <Button
        buttonStyle="primary"
        data-testid={taskIncompleteModalLeaveButtonTestId}
        onClick={handleLeave}
      >
        Leave
      </Button>
    </FooterButtonContainer>
  );

  return (
    <StyledModal
      containerTestId={taskIncompleteModalContainerTestId}
      footer={modalFooter}
      isOpen={isOpen}
      maxWidth="500px"
      size="small"
      title="Task in Progress"
      onClose={onStay}
    >
      <ModalContent data-testid={taskIncompleteModalContentTestId}>
        <b>
          If you leave without completing this communication, the task in
          progress will not be completed.
        </b>
        <CheckboxContainer>
          <CheckBox
            checked={dontShowAgain}
            data-testid={taskIncompleteModalCheckboxTestId}
            id="task-incomplete-dont-show-again"
            label={
              <CheckboxLabel>
                {"Don't show this alert when leaving communication task"}
              </CheckboxLabel>
            }
            value="0"
            onChange={handleCheckboxChange}
          />
        </CheckboxContainer>
      </ModalContent>
    </StyledModal>
  );
}

export default TaskIncompleteModal;
